import moment from 'moment';
import React, { useMemo } from 'react';
import { Popover, Tag, Typography, Tooltip } from 'antd';
import './index.less';
const { Text } = Typography;

const prefixCls = 'yx-calendar-activity-item';

export default React.memo(({ activityInfo, rangeMode, startDate, endDate }) => {
  const {
    version,
    activityName,
    activityBeginTime,
    activityEndTime,
    levelName = '',
    businessStartTime, //报名时间
    businessEndTime,
    pendingActivityBeginTime,
    pendingActivityEndTime,
  } = activityInfo || {};
  // 渲染活动级别
  const renderTag = () => {
    let tagClassName = 'tag-area-normal';
    if (levelName.indexOf('平台大促') !== -1) {
      tagClassName = 'tag-area-special';
    } else if (!rangeMode) {
      tagClassName = tagClassName + ' special';
    }
    if (activityIsEnd) {
      tagClassName = 'tag-area-end';
    }
    return <Tag className={tagClassName}>{levelName}</Tag>;
  };
  // 获取活动状态
  const getStatus = () => {
    //待开启 报名未开始且活动未开始
    if (moment() < moment(businessStartTime) && moment() < moment(activityBeginTime)) {
      return (
        <>
          <img
            src="//img30.360buyimg.com/pop/jfs/t1/90488/34/41030/274/662b83e6Ff97d70a1/66eb88b1df3d4469.png"
            alt=""
            width={'12px'}
            height={'12px'}
            style={{ marginLeft: '4px' }}
          />
          <span className={'card-status-tag normal-end'}>待开启</span>
        </>
      );
    }
    //报名开始且活动未开始：待开启丨报名中
    if (
      moment() > moment(businessStartTime) &&
      moment() < moment(businessEndTime) &&
      moment() < moment(activityBeginTime)
    ) {
      return (
        <>
          <img
            src="//img30.360buyimg.com/pop/jfs/t1/155788/4/44118/585/6624c746F96b289e9/eda51c21350162f1.png"
            alt=""
            width={'12px'}
            height={'12px'}
            style={{ marginLeft: '4px' }}
          />
          <span className="card-status-tag normal">待开启</span>
          <span style={{ margin: '0 4px', color: 'red' }}>|</span>
          <span className="card-status-tag normal">报名中</span>
        </>
      );
    }
    //报名结束且活动未开始：待开启丨报名截止
    if (moment() > moment(businessEndTime) && moment() < moment(activityBeginTime)) {
      return (
        <>
          <img
            src="//img30.360buyimg.com/pop/jfs/t1/90488/34/41030/274/662b83e6Ff97d70a1/66eb88b1df3d4469.png"
            alt=""
            width={'12px'}
            height={'12px'}
            style={{ marginLeft: '4px', marginRight: '2px' }}
          />
          <span className="card-status-tag normal" style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
            待开启
          </span>
          <span style={{ margin: '0 4px', color: 'rgba(0, 0, 0, 0.45)' }}>|</span>
          <span className="card-status-tag normal" style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
            报名截止
          </span>
        </>
      );
    }
    //活动已开始且可报名：活动中丨可报名
    if (moment() < moment(businessEndTime) && moment() > moment(activityBeginTime)) {
      // 待定判断
      if (pendingActivityBeginTime || pendingActivityEndTime) {
        return (
          <>
            <img
              src="//img30.360buyimg.com/pop/jfs/t1/155788/4/44118/585/6624c746F96b289e9/eda51c21350162f1.png"
              alt=""
              width={'12px'}
              height={'12px'}
              style={{ marginLeft: '4px' }}
            />
            <span className="card-status-tag normal">待开启</span>
            <span style={{ margin: '0 4px', color: 'red' }}>|</span>
            <span className="card-status-tag normal">可报名</span>
          </>
        );
      }
      return (
        <>
          <img
            src="//img30.360buyimg.com/pop/jfs/t1/155788/4/44118/585/6624c746F96b289e9/eda51c21350162f1.png"
            alt=""
            width={'12px'}
            height={'12px'}
            style={{ marginLeft: '4px', marginRight: '2px' }}
          />
          <span className="card-status-tag normal">活动中</span>
          <span style={{ margin: '0 4px', color: 'red' }}>|</span>
          <span className="card-status-tag normal">可报名</span>
        </>
      );
    }
    //活动已开始且报名截止
    if (
      moment() > moment(businessEndTime) &&
      moment() > moment(activityBeginTime) &&
      moment() < moment(activityEndTime)
    ) {
      return (
        <>
          <img
            src="//img30.360buyimg.com/pop/jfs/t1/216885/7/38814/594/662635c9F79806ede/254c836a11c52ed2.png"
            alt=""
            width={'12px'}
            height={'12px'}
            style={{ marginLeft: '4px', marginRight: '2px' }}
          />
          <span className="card-status-tag normal" style={{ color: 'black' }}>
            活动中
          </span>
          <span style={{ margin: '0 4px' }}>|</span>
          <span className="card-status-tag normal" style={{ color: 'black' }}>
            报名截止
          </span>
        </>
      );
    }
    //活动结束
    if (moment() > moment(activityEndTime)) {
      // 待定判断
      if (pendingActivityBeginTime || pendingActivityEndTime) {
        return (
          <>
            <img
              src="//img30.360buyimg.com/pop/jfs/t1/90488/34/41030/274/662b83e6Ff97d70a1/66eb88b1df3d4469.png"
              alt=""
              width={'12px'}
              height={'12px'}
              style={{ marginLeft: '4px', marginRight: '2px' }}
            />
            <span className={'card-status-tag normal-end'}>待开启</span>
          </>
        );
      }
      return (
        <>
          <img
            src="//img30.360buyimg.com/pop/jfs/t1/90488/34/41030/274/662b83e6Ff97d70a1/66eb88b1df3d4469.png"
            alt=""
            width={'12px'}
            height={'12px'}
            style={{ marginLeft: '4px', marginRight: '2px' }}
          />
          <span className={'card-status-tag normal-end'}>已结束</span>
        </>
      );
    }
    return null;
  };
  // 获取活动状态
  const getStatusText = () => {
    if (moment() < moment(businessStartTime)) {
      return <div className={'tooltip-status-tag normal'}>待报名</div>;
    }
    if (moment() > moment(businessStartTime) && moment() < moment(businessEndTime)) {
      return <div className={'tooltip-status-tag normal'}>报名中</div>;
    }
    if (moment() > moment(businessEndTime) && moment() < moment(activityEndTime)) {
      return <div className={'tooltip-status-tag normal'}>报名截止</div>;
    }
    if (moment() > moment(activityEndTime)) {
      //有待定时间
      if (pendingActivityBeginTime || pendingActivityEndTime) {
        return <div className={'tooltip-status-tag normal'}>待开启</div>;
      }
      return <div className={'tooltip-status-tag normal-end'}>已结束</div>;
    }
    return '';
  };
  //活动结束标识符
  const activityIsEnd = useMemo(() => {
    return moment() > moment(activityEndTime);
  }, [activityEndTime]);
  // 显示活动或者招商活动时间
  const renderTime = () => {
    const timeElement = (
      <Text ellipsis style={{ marginLeft: 10, fontSize: 12, color: 'rgba(0, 0, 0, 0.35)' }}>
        活动时间：{pendingActivityBeginTime || moment(activityBeginTime).format('MM.DD')}-
        {pendingActivityEndTime || moment(activityEndTime).format('MM.DD')}
      </Text>
    );
    if (version === 2) {
      return (
        <React.Fragment>
          <Text ellipsis style={{ marginLeft: 10, fontSize: 12, color: 'rgba(0, 0, 0, 0.35)' }}>
            报名时间：{moment(businessStartTime).format('MM.DD')}-{moment(businessEndTime).format('MM.DD')}
          </Text>
          {timeElement}
        </React.Fragment>
      );
    }
    return timeElement;
  };
  const tooltipTitle = (
    <div>
      <span style={{ marginRight: 12 }}>{activityName}</span>
      {getStatusText()}
      <span style={{ marginLeft: 4 }}>
        {moment(businessStartTime).format('MM.DD')}-{moment(businessEndTime).format('MM.DD')}
      </span>
      <span style={{ margin: '0 8px' }}>|</span>
      <span>
        活动时间：{pendingActivityBeginTime || moment(activityBeginTime).format('MM.DD')}-
        {pendingActivityEndTime || moment(activityEndTime).format('MM.DD')}
      </span>
    </div>
  );
  //判断是长卡片还是短卡片

  const isFull = useMemo(() => {
    let res = true;
    //活动结束时间在当前月份加1(当前4月 + 1 =》 5月1)之前,显示一半
    if (moment(activityEndTime) <= moment(startDate).add(1, 'M')) {
      res = false;
    }
    if (moment(version == 2 ? businessStartTime : activityBeginTime) >= moment(startDate).add(1, 'M')) {
      res = false;
    }
    return res;
  }, [activityInfo]);
  return (
    <Tooltip overlayStyle={{ maxWidth: 1200 }} title={tooltipTitle}>
      <div className={`${prefixCls}`}>
        <div
          className={`${prefixCls}-tag-container ${!rangeMode && 'special'}`}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          {renderTag()}
          <Text
            style={{
              fontFamily: 'PingFang SC',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '20px',
              marginRight: '8px',
            }}
            disabled={activityIsEnd}
          >
            {activityName}
          </Text>
          <Text disabled={activityIsEnd}>{getStatus() ? getStatus() : null}</Text>
          {isFull ? renderTime() : null}
        </div>
      </div>
    </Tooltip>
  );
});
